document.addEventListener('DOMContentLoaded', function () {
    $('.animated-heart-link').tooltip({
        delay: {
            show: 500,
            hide: 0
        },
        customClass: 'font-heading'
    });
});